import { withTheme } from '../config';
import LinearProgress from './LinearProgress';
export default withTheme(LinearProgress, 'LinearProgress');
